import Ajax from 'global/od/Ajax';
import setRRConfigSearch from './setRRConfigSearch';

const { events } = window.od;

const hybrisEnrichment = {
	init() {
		this.firstRequest = true;
	},

	fetchEnrichedProductData() {
		// If there is already a timeout, cancel it
		if (typeof this.timeoutId === 'number') {
			clearTimeout(this.timeoutId);
		}

		if (this.firstRequest) {
			this.timeoutId = setTimeout(this.renderProductTiles.bind(this), 150);
		} else {
			this.timeoutId = setTimeout(this.renderProductTiles.bind(this), 700);
		}
	},

	renderProductTiles() {
		this.firstRequest = false;

		const filteredTileIds = this.getUnenrichedTileIds();
		setRRConfigSearch(filteredTileIds);

		if (Array.isArray(filteredTileIds) && filteredTileIds.length) {
			this.fetchEnrichedDataAsJson(filteredTileIds).then(responseData => {
				if (typeof responseData?.data === 'string') {
					const enrichedDataJson = JSON.parse(
						responseData.data.replace(/[\t\n]/g, ' '),
					);

					enrichedDataJson.hits.forEach(hit => {
						this.renderProductPricePanel(
							hit.legacyProductId,
							hit.pricePanelHtml?.replaceAll('\\"', '"'),
						);
						this.renderHtmlFragment(
							`.ais-Hits-list .product-lister-item[data-legacy-sku="${hit.legacyProductId}"] .product-lister-item__pricing-table`,
							hit.productPriceTableHtml?.replaceAll('\\"', '"'),
						);
						this.renderHtmlFragment(
							`.ais-Hits-list .product-lister-item[data-legacy-sku="${hit.legacyProductId}"] .product-lister-item__add-to-cart-panel`,
							hit.addToCartHtml?.replaceAll('\\"', '"'),
						);
						this.renderHtmlFragment(
							`.ais-Hits-list .product-lister-item[data-legacy-sku="${hit.legacyProductId}"] .product-lister-item__deal-badge-list`,
							hit.dealBadgeListHtml?.replaceAll('\\"', '"'),
						);

						this.renderHtmlFragment(
							`.ais-Hits-list .product-lister-item[data-legacy-sku="${hit.legacyProductId}"] .product-lister-item__deal-badge-list-mobile`,
							hit.dealBadgeListMobileHtml?.replaceAll('\\"', '"'),
						);
					});

					events.publish('algolia_hybrisEnrichment_renderedProductTiles', {
						element: document.querySelector('.ais-Hits-list'),
					});
				}
			});
		}
	},

	renderProductPricePanel(legacyProductId, htmlFragment) {
		const tileElement = document.querySelector(
			`.ais-Hits-list .product-lister-item[data-legacy-sku="${legacyProductId}"]`,
		);
		const pricePanelElement = document.querySelector(
			`.ais-Hits-list .product-lister-item[data-legacy-sku="${legacyProductId}"] .product-lister-item__price`,
		);

		tileElement?.classList.remove('product-lister-item--basicInfo');

		if (pricePanelElement) {
			pricePanelElement.innerHTML = htmlFragment;
		}
	},

	renderHtmlFragment(selectors, htmlFragment) {
		const element = document.querySelector(selectors);

		if (element) {
			element.innerHTML = htmlFragment;
		}
	},

	getUnenrichedTileIds() {
		const basicInfoTiles = document.querySelectorAll(
			'.product-lister-item--basicInfo',
		);
		const basicInfoTileSkus = Array.from(basicInfoTiles).map(basicInfoTile =>
			basicInfoTile.getAttribute('data-legacy-sku'),
		);

		return basicInfoTileSkus;
	},

	fetchEnrichedDataAsJson(productIds) {
		return new Promise((resolve, reject) => {
			Ajax({
				method: 'GET',
				url: '/ajax/product/algolia-search-list',
				data: {
					productIds: productIds.join(','),
				},
				Accept: 'text/html',
			})
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
};

export default hybrisEnrichment;
